module.exports = __webpack_public_path__ + "static/media/ic_logo.8ff9849b.png";